import { render, staticRenderFns } from "./RefsPartner.vue?vue&type=template&id=35f921bc"
import script from "./RefsPartner.vue?vue&type=script&lang=ts"
export * from "./RefsPartner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports